import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface ProgressPercentageDTO {
  percentageValue: number;
}

export class ProgressPercentage {
  readonly isProgressPercentageProgressPercentage: boolean = true;

  readonly percentageValue: number;

  static readonly constraints = {
    "percentageValue": {
      "minValue": 0,
      "maxValue": 100,
    }
  }

  constructor(
  percentageValue: number
  ) {
    ProgressPercentage.validatePercentageValue(percentageValue);
    this.percentageValue = percentageValue;
  }

  static fromDTO(dto: ProgressPercentageDTO): ProgressPercentage {
    const percentageValue = getInt32(dto, "percentageValue", InvalidProgressPercentagePercentageValueError);
    return new ProgressPercentage(
      percentageValue
    );
  }

  toDTO(): ProgressPercentageDTO {
    const dto: ProgressPercentageDTO = {
        percentageValue: this.percentageValue
    };
    return dto;
  }
  private static validatePercentageValue = (percentageValue: number): void => {
    if(percentageValue < 0) {
      throw new InvalidProgressPercentagePercentageValueMinValueError(
        0,
        `Attribute percentageValue has value ${percentageValue}. Min value is 0.`
      );
    }
    if(percentageValue > 100) {
      throw new InvalidProgressPercentagePercentageValueMaxValueError(
        100,
        `Attribute percentageValue has value ${percentageValue}. Max value is 100.`
      );
    }
  }
  
}

ProgressPercentage.prototype.toString = function toString(): string {
  return `ProgressPercentage(percentageValue='${this.percentageValue}')`;
};

export class InvalidProgressPercentageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProgressPercentageError";
  }
}
export class InvalidProgressPercentagePercentageValueError extends InvalidProgressPercentageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProgressPercentagePercentageValueError";
  }
}

export class InvalidProgressPercentagePercentageValueMaxValueError extends InvalidProgressPercentagePercentageValueError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProgressPercentagePercentageValueMaxValueError";
  }
}

export class InvalidProgressPercentagePercentageValueMinValueError extends InvalidProgressPercentagePercentageValueError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProgressPercentagePercentageValueMinValueError";
  }
}
